import React from 'react'
import { connect } from 'react-redux'
import Button from '../components/Button.jsx'

const ReferencesFooterContainer = props => (
    <div className="references-footer-container">
        <div className="references-footer-image hidden-sm hidden-xs">
            <img
                className="references-footer-image__image"
                src="/images/el/bed_building.png"
            />
        </div>
        <div className="container">
            <div className="row">
                <div className="col-md-6 col-md-offset-6">
                    <h3 className="references-footer-title">
                        <span
                            className="references-footer-titleblack"
                        >
                            {`${props.langData.footerTitle1} `}
                        </span>
                        {props.langData.footerTitle2}
                    </h3>
                    <p className="paragraph references-footer-text">{props.langData.footerText}</p>
                    <div className="references-footer-button">
                        <Button
                            link="/kontakt"
                            text={props.langData.footerButton}
                            type="white"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
)

const mapStateToProps = state => ({
    langData: state.langData.references
})

export default connect(mapStateToProps)(ReferencesFooterContainer)



// WEBPACK FOOTER //
// ./src/scripts/containers/ReferencesFooterContainer.jsx